module.exports = __webpack_public_path__ + "img/yj_recall_bg_top2.1a47a5f1.png";